import { Assessment, Section } from '@playbooks/core/src/interfaces/ActionCard'

function isAssessmentAutoCollapsing(section: Section, assessment: Assessment) {
  return assessment.isAutoCollapse ?? section.isAutoCollapse ?? false
}

export default isAssessmentAutoCollapsing
